<template>
    <div>
        <Header/>
        <div ref="content">
        <Swipe :banners="bannerList"/>
        <div class="blank20"/>
        <Adver v-if="Object.hasOwnProperty.call(advBdaObj,'content') && newsObj[2]" :obj="{bda:advBdaObj,cfda:advCfdaObj,index_video:advVideoObj}" :imageSwiper="newsObj[2].slice(0,5)" />
        <div v-if="newsObj[0]" class="main-page-content">
            <div class="news">
                <NewsMarquee :arr="newsObj[0]" :type="1" class="single"/>
                <Notice :arr="newsObj[1]" />
                <fast-menu class="single"/>
                <NewsModule :arr="newsObj[3]" :type="4" class="single"/>
            </div>
            <!-- <div class="news">
                <NewsModule :arr="newsObj[0]" :type="1" class="single"/>
                <NewsModule :arr="newsObj[1]" :type="2" class="single"/>
                <NewsModule :arr="newsObj[2]" :type="3" class="single"/>
                <NewsModule :arr="newsObj[3]" :type="4" class="single"/>
            </div> -->
        </div>
        <ShouQuanJiGou :arr="orgList" v-if="orgList[0]"/>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import NewsModule from './components/newsModule';
import ShouQuanJiGou from './components/shouquanjigou';
import Swipe from './components/swipe';
import Adver from './components/adver';
import Notice from './components/notice.vue';
import NewsMarquee from './components/newsMarquee.vue';
import FastMenu from './components/fastMenu.vue';
export default {
    computed: mapState([
        'advCfdaObj',
        'advBdaObj',
        'advVideoObj',
    ]),
    components:{
        NewsModule,
        ShouQuanJiGou,
        Swipe,
        Adver,
        Notice,
        NewsMarquee,
        FastMenu
    },
    data() {
        return {
            bannerList:[],
            newsObj:{},
            orgList:[],
        }
    },
    mounted(){
        const screenHeight = window.innerHeight;
        this.$refs.content.style.minHeight = screenHeight - 324 + 'px';
        this.getBanners();
        this.getNews();
        this.getOrgList();
    },
    methods: {
        async getBanners(){
            try {
                const res = await this.$http.get('/api/index/getBannerList');
                res.length&&(this.bannerList = res);
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
        },
        async getNews(){
            const res = await this.$http.get('/api/index/getNewsList',{is_index:1});
            this.newsObj = res;
            console.log('getNews',res);
        },
        async getOrgList(){
            const res = await this.$http.get('/api/index/getOrgList',{is_index:1,limit:1000});
            res.length&&(this.orgList = res);
        },
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
</style>
